import api from "./api";
import currentUserId from "../reduxSaga/sagas/requests/currentUserId";
import UtilsUrl from "../utils/UtilsUrl";

// const BASE_BK_URL = "http://localhost:8082/gateway/finance/Banque"
// const BASE_BK_URL = "http://192.168.1.112:8082/gateway/finance/Banque"

class BanqueService {
  getAllBanqueNames() {
    return api.get(UtilsUrl.bankURL() + "/getAllBanque");
  }
  getAllAgenceNames(banqueName) {
    return api.get(UtilsUrl.bankURL() + "/getAllAgencesBanque/" + banqueName);
  }

  //new
  getAllAgenceAndBank(idUser) {
    return api.get("/retail/banque/getAllAgenceAndBank/" + idUser);
  }

  addBankAccount(addbanque) {
    return api.post(`/retail/banque/addBankAccount`, addbanque);
  }

  getAllBankAccounts(type) {
    let currentUser = currentUserId();
    return api.get(`/retail/banque/getAllBankAccounts/${currentUser}/${type}`);
  }
  getAllAccounts() {
    let currentUser = currentUserId();
    return api.get(`/retail/banque/getAllBankAccounts/${currentUser}`);
  }
  getBankAccountInfo(id) {
    return api.get(`/retail/banque/getBankAccountInfo/${id}`);
  }
  getListPayementsByBankAccount(id) {
    return api.get(`/sales/payement/getListPayementsByBankAccount/${id}`);
  }
  getListPayementsByBankAccountV2(id,dateBegin,dateEnd,typePayementValidation) {
    return api.get("/sales/payement/getListPayementsByBankAccountV2/"+id+"/"+dateBegin+"/"+dateEnd+"/"+typePayementValidation);
  }
  getListPayementsChequeByBankAccountBetweenDates(idUser,idBanque,typePayement,beginDate,endDate) {
    return api.get(`/sales/payement/getListPayementsChequeByBankAccountBetweenDates/${idUser}/${idBanque}/${typePayement}/${beginDate}/${endDate}`);
  }

  getEcheance(idBanque,beginDate,endDate) {
    return api.get("/sales/payement/getEcheance/"+idBanque+"/"+beginDate+"/"+endDate);
  }

  getAllEcheance(idUser,beginDate,endDate) {
    return api.get("/sales/payement/getAllEcheance/"+idUser+"/"+beginDate+"/"+endDate);
  }

    getListPayementsForExtrait(idUser,idBanqueAccount,dateDebutToFilter,dateFinToFilter) {
    return api.get("/retail/banque/generateExtraitBancaire/"+idUser+"/"+idBanqueAccount,{
      params: {
        dateDebutToFilter: dateDebutToFilter,
        dateFinToFilter: dateFinToFilter,
      },
    });
  }
}

export default new BanqueService();
